// Router Dashboard - OA
export default [
  {
    path: 'teams',
    name: 'teams',
    component: () => import(/* webpackChunkName: "dashboard-oa" */ '../../../views/dashboard/content/OA/teams/TeamsList.vue'),
    meta: {
      roles: ['OA'],
      navMenuOptions: {
        index: '60',
        label: 'aside.teams',
        icon: 'custom-teams',
      },
    },
  },
  {
    path: 'team/:id',
    name: 'teamDetail',
    component: () => import(/* webpackChunkName: "dashboard-oa" */ '../../../views/dashboard/content/OA/teams/TeamDetails.vue'),
    meta: {
      roles: ['OA'],
      navMenuOptions: {
        as: 'teams',
      },
    },
  },
  {
    path: 'leaders',
    name: 'leaders',
    component: () => import(/* webpackChunkName: "dashboard-oa" */ '../../../views/dashboard/content/OA/leaders/LeadersList.vue'),
    meta: {
      roles: ['OA'],
      navMenuOptions: {
        index: '70',
        label: 'aside.leaders',
        icon: 'el-icon-s-custom',
      },
    },
  },
  {
    path: 'leaders/:id',
    name: 'leaderDetail',
    component: () => import(/* webpackChunkName: "dashboard-oa" */ '../../../views/dashboard/content/OA/leaders/LeaderDetails.vue'),
    meta: {
      roles: ['OA'],
      navMenuOptions: {
        as: 'leaders',
        icon: 'custom-teams',
      },
    },
  },
  // {
  //   path: 'invoice/in/leader',
  //   name: 'invoicesInForOA',
  //   component: () => import(/* webpackChunkName:
  //   "dashboard-oa" */ '../../../views/dashboard/content/OA/invoices/InvoicesInList.vue'),
  //   meta: {
  //     roles: ['OA'],
  //     navMenuOptions: {
  //       index: '85',
  //       label: 'aside.invoicesIn',
  //       as: 'Invoices',
  //       icon: 'custom-invoices',
  //       // status: 'staging',
  //     },
  //   },
  // },
  // {
  //   path: 'line-managers',
  //   name: 'lineManagers',
  //   component:()=>import('./views/dashboard/content/OA/lineManagers/LineManagersList.vue'),
  //   meta: {
  //     roles: ['OA'],
  //     navMenuOptions: {
  //       index: '80',
  //       label: 'aside.lineManagers',
  //       icon: 'custom-briefcase',
  //     },
  //   },
  // },
  {
    path: 'line-managers/:id',
    name: 'lineManagerDetail',
    component: () => import(/* webpackChunkName: "dashboard-oa" */ '../../../views/dashboard/content/OA/lineManagers/LineManagerDetails.vue'),
    meta: {
      roles: ['OA'],
      navMenuOptions: {
        as: 'lineManagers',
      },
    },
  },
];
